<app-header></app-header>
<div class="ng-content" [ngClass]="{'hidden-menu-content': !isMenuVisible}">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>